import { useState } from 'react'
import { icons } from '../assets'

function CopyData({ data, withText = false, customText }: { data: string, withText?: boolean, customText?: string }) {
  const [copied, setCopied] = useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(data)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 3000)
  }
  return (
    <span className='w-fit flex items-center gap-1 text-sm text-az-teal cursor-pointer whitespace-nowrap text-nowrap' onClick={() => handleCopy()}>
      {
        copied ? (<img src={icons.checkMark} className='w-[15px] h-[15px] object-cover' alt='Copied' />) : (<img src={icons.copyicon} className='w-[15px] h-[15px]  object-cover' alt='Copy' />)
      }
      {withText && customText ? customText : withText ? "copy" : null}
    </span>
  )
}

export default CopyData